import { useToastContext } from "components/alert/ToastContext";
import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import Usuario from "model/administracao/cadastro/Usuario";
import AcaoAuditoria from "model/auditoria5s/auditoria/AcaoAuditoria";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useEffect, useState } from "react";
import AcaoAuditoriaService from "service/auditoria5s/AcaoAuditoriaService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { converterData } from "utils/convert";

const acaoAuditoriaService = new AcaoAuditoriaService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function AcaoAuditoriaCadastro() {

    const titulo = "Ação";
    const [acaoAuditoria, setAcaoAuditoria] = useState<AcaoAuditoria>(new AcaoAuditoria());

    const [visibleCancelarAuditoria, setVisibleCancelarAuditoria] = useState(false);
    const [podeCancelarAuditoria, setPodeCancelarAuditoria] = useState(false);

    const [usuariosDisponiveis, setUsuariosDisponiveis] = useState<Usuario[]>([]);

    const [visibleModalImage, setVisibleModalImage] = useState(false);

    const { msgAlerta } = useToastContext();

    function validar(){
        return false;
    }

    useEffect(() => {
        acaoAuditoriaService.getUsuarios().then((response) => {
            setUsuariosDisponiveis(response);
        });
    }, []);


    return (

        <BaseCadastro 
            model={acaoAuditoria} 
            service={acaoAuditoriaService} 
            setModel={(value: AcaoAuditoria) => setAcaoAuditoria(value)} 
            validar={() => validar()} 
            urlService="/acaoAuditoria" pathCadastro="/acaoAuditoria" tituloPagina={'Ação'}
            showGravarButton={false}    
        >
            {titulo ?
                <div className="row">
                    <Label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</Label>
                </div>
                : null}

            <div className="row">
                <Label className="col col-sm-12">Nome</Label>
                <div className="col-sm-12">
                    <InputText value={acaoAuditoria.nome} readOnly style={{ width: '30%' }} />
                </div>
            </div>
            <div className="row">
                <Label className="col col-sm-12">Descrição</Label>
                <div className="col-sm-12">
                    <InputTextarea value={acaoAuditoria.descricao} readOnly style={{ width: '30%' }} />
                </div>
            </div>
            <div className="row">
                <Label className="col col-sm-12">Setor</Label>
                <div className="col-sm-12">
                    <InputText value={acaoAuditoria?.itemAuditoria?.classeAuditoria?.auditoria?.setor?.nome} readOnly style={{ width: '30%' }} />
                </div>

            </div>

            <div className="row">
                <Label className="col col-sm-12">Responsavel</Label>
                <div className="col-sm-12">
                    <InputText
                        value={acaoAuditoria.responsavel?.nome}
                        style={{ width: '30%' }}
                    />
                </div>
            </div>
            
            <div className="row">
                <Label className="col col-sm-12">Data de criação</Label>
                <div className="col-sm-12">
                    <InputText value={converterData(acaoAuditoria.createdAt)} readOnly style={{ width: '15%' }} />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Data Limite</Label>
                <div className="col-sm-12">
                    <InputText value={converterData(acaoAuditoria.dataLimite)} readOnly style={{ width: '15%' }} />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Status</Label>
                <div className="col-sm-12">
                    <Dropdown
                        value={acaoAuditoria.status}
                        optionValue="value"
                        optionLabel="Label"
                        optionDisabled={(option) => {
                            return true;
                        }}
                        options={[
                            { value: "CRIADO", Label: "Criado" },
                            { value: "EM_ANDAMENTO", Label: "Em andamento" },
                            { value: "FINALIZADO", Label: "Finalizado" }
                        ]}
                        style={{ width: '15%' }}
                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Resposta</Label>
                <div className="col-sm-12">
                    <InputTextarea value={acaoAuditoria.resposta} readOnly style={{ width: '30%' }} />
                </div>
            </div>
        </BaseCadastro>
    )
}